import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Checkbox, Heading, Paragraph, ValidationMessage } from '@digdir/designsystemet-react';

import { OppvarmingFormData } from '../../../types';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { Gasskjel } from './kjel';
import { Gasskamin } from './gasskamin';

export const Gass = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.gass' });
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const gassSelected = watch('gass.selected');
  const oppvarmingSelectionError = formState.errors?.gass?.selected?.message;

  const gassSelectionError = formState.errors?.gass?.value?.kamin?.selected?.message;

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!oppvarmingSelectionError}
        label={t('label')}
        {...register('gass.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {gassSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('heading')}
            </Heading>
            <Paragraph>{t('description')}</Paragraph>
          </LeftBorderedContent>

          <Gasskamin />
          <Gasskjel />
          {gassSelectionError && (
            <LeftBorderedContent>
              <ValidationMessage>{gassSelectionError}</ValidationMessage>
            </LeftBorderedContent>
          )}
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
